module.exports = __webpack_public_path__ + "static/media/1.255fe6a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16005/1.jpg
// module id = 498
// module chunks = 0